import { render, staticRenderFns } from "./FormTitle.vue?vue&type=template&id=aba69642&scoped=true&"
import script from "./FormTitle.vue?vue&type=script&lang=js&"
export * from "./FormTitle.vue?vue&type=script&lang=js&"
import style0 from "./FormTitle.vue?vue&type=style&index=0&id=aba69642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba69642",
  null
  
)

export default component.exports